import capitalizeFirstLetter from './capitalizeFirstLetter'

const addSpaceToString = value => (
  capitalizeFirstLetter(value.replace(/([A-Z])/g, ' $1').trim())
)

export default addSpaceToString
